import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  boTrendReport,
  getGraphDataDevDept,
  getVendorTableData,
} from "../api/boTrend";

export const fetchGraphDataDevDept = createAsyncThunk(
  "boTrend/fetchGraphDataDevDept",
  async (params) =>
    getGraphDataDevDept(
      params?.startDate,
      params?.endDate,
      params?.duration,
      params?.division,
      params?.department,
      params?.vendor,
      params?.location,
      params?.page,
      params?.limit
    ).then((res) => res)
);

export const fetchVendorTable = createAsyncThunk(
  "boTrend/fetchVendorTable",
  async (params) =>
    getVendorTableData(
      params?.startDate,
      params?.endDate,
      params?.duration,
      params?.division,
      params?.department,
      params?.vendor,
      params?.location,
      params?.page,
      params?.limit,
      params?.sort
    ).then((res) => res)
);

export const fetchBoTrendReport = createAsyncThunk(
  "boTrend/fetchBoTrendReport",
  async (params) =>
    boTrendReport(
      params?.startDate,
      params?.endDate,
      params?.division,
      params?.department,
      params?.vendor,
      params?.location
    ).then((res) => res)
);

export const boTrendSlice = createSlice({
  name: "boTrend",
  initialState: {
    graphDataDevDept: null,
    vendorTableData: null,
    boTrendReport: null,
    loading: false,
  },
  extraReducers: {
    [fetchGraphDataDevDept.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchGraphDataDevDept.fulfilled]: (state, { payload }) => {
      state.graphDataDevDept = payload;
      state.loading = false;
    },
    [fetchGraphDataDevDept.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchVendorTable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchVendorTable.fulfilled]: (state, { payload }) => {
      state.vendorTableData = payload;
      state.loading = false;
    },
    [fetchVendorTable.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchBoTrendReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchBoTrendReport.fulfilled]: (state, { payload }) => {
      state.boTrendReport = payload;
      state.loading = false;
    },
    [fetchBoTrendReport.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default boTrendSlice.reducer;
